import React from 'react';
import { Navigate } from 'react-router-dom';
import { compileWithArgs } from 'src/js/helper/path-to-regexp-helper';
import { useStores } from 'src/js/hook/use-stores';
import { Paths } from 'src/js/route';
import { constant } from 'src/js/constant';
import { useReadLocalStorage } from 'usehooks-ts';

import { AudioEncodersPage } from './audio-encoder/audio-encoder';
import { EssencesPage } from './essence/essence';
import { LogosPage } from './logos/logos';
import { MetadataPage } from './metadata/metadata';
import { SctePage } from './scte/scte';
import { StreamsPage } from './stream/stream';
import { VideoEncodersPage } from './video-encoder/video-encoder';

export type StreamPageParameters = {
  page?: StreamKey;
};

export enum StreamKey {
  INPUTS = 'input',
  STREAMS = 'stream',
  VIDENC = 'videnc',
  AUDENC = 'audenc',
  METADATA = 'metadata',
  ADINSERTIONS = 'scte',
  LOGOS = 'logos',
}

export const DefaultStreamsRoute: React.FunctionComponent = () => {
  const { sessionStore } = useStores();
  const selectedTab =
    useReadLocalStorage(`${constant.lStorage.streamingTab}:${sessionStore.username}`) ?? StreamKey.STREAMS;

  return (
    <Navigate
      to={compileWithArgs<StreamPageParameters>(Paths.streaming)({
        page: selectedTab as StreamKey, // show page in localstorage if a direct section access without any specific page
      })}
      replace={
        true
      } /* replace current entry in history stack instead of adding new one, thus allowing to use back button a single time to go back (as expected) instead of two */
    />
  );
};

export const StreamsRoutes = [
  {
    path: '',
    element: <DefaultStreamsRoute />,
  },
  {
    path: StreamKey.INPUTS,
    element: <EssencesPage />,
  },
  {
    path: StreamKey.STREAMS,
    element: <StreamsPage />,
  },
  {
    path: StreamKey.VIDENC,
    element: <VideoEncodersPage />,
  },
  {
    path: StreamKey.AUDENC,
    element: <AudioEncodersPage />,
  },
  {
    path: StreamKey.METADATA,
    element: <MetadataPage />,
  },
  {
    path: StreamKey.ADINSERTIONS,
    element: <SctePage />,
  },
  {
    path: StreamKey.LOGOS,
    element: <LogosPage />,
  },
];
